import { ApiError } from 'api/schema'

/** True when GET /robot/:id returned 404 (robot does not exist). */
export function isRobotNotFoundError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404
}
